import { TextFileComponent } from './TextFileComponent.main';

export { TextFileComponent };
